import { render } from "./PickerFotoPerizia.vue?vue&type=template&id=7c262b7c&scoped=true"
import script from "./PickerFotoPerizia.vue?vue&type=script&lang=js"
export * from "./PickerFotoPerizia.vue?vue&type=script&lang=js"

import "./PickerFotoPerizia.vue?vue&type=style&index=0&id=7c262b7c&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c262b7c"]])

export default __exports__